import { useEffect } from "react";
import cmsParser from "../../Services/CMSParser";
import cms from "../../../constants/cmskeys";

const ListRemovalFailure = ({ cmsLabels }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        height: "50vh",
      }}
    >
      <div className="dds__message-bar--error dds__message-bar__content--center dds__align-items-center dds__mt-4 dds__p-3">
        <div className="dds__d-flex dds__align-items-center">
          <i className="dds__icon dds__font-weight-bold dds__icon--alert-error dds__mr-3 dds__text--error"></i>
          <span className="dds__font-weight-bold">
            {cmsParser(cms.failed_unsubscribe, cmsLabels)}
          </span>
        </div>
      </div>
    </div>
  );
};
export default ListRemovalFailure;
